import { connect } from 'react-redux';
import { State } from 'reducers';
import { getFilterText } from 'selectors/monitoringSelectors';
import { filterDevices } from 'actions/monitoringActions';
import { CameraFilter as GenericCameraFilter } from 'ui/shared/CameraFilter';
import { compose, withProps } from 'recompose';

// Take the generic CameraFilter control and hook it up to the Monitoring infrastructure

type StateProps = {
    filterText: string;
};
type DispProps = {
    onChange: (filterText: string) => void;
};

const mapStateToProps = (state: State): StateProps  => ({
    filterText: getFilterText(state),
});
const mapDispatchToProps = (dispatch: Function): DispProps => ({
    onChange: (filterText: string) => dispatch(filterDevices(filterText)),
});

type RecomposeProps = {
    id: string;
};

export const CameraFilter = compose<RecomposeProps & StateProps & DispProps, {}>(
    withProps({
        id: 'device-tree-filter',
    }),
    connect<StateProps, DispProps, {}>(mapStateToProps, mapDispatchToProps),
)(GenericCameraFilter);




// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/sidePanel/CameraFilter.tsx